import React, { FC } from 'react';
import arrowImg from './assets/synchronize-arrows-square.png';
import tickImg from './assets/Tick.png';
import { LeftIcon, LineWrapper } from './style';
import { Paragraph } from 'hui';

const ParseSucceeded: FC<{}> = () => (
  <div>
    <LineWrapper>
      <LeftIcon alt="synchronize arrows square" src={arrowImg} />
      <Paragraph mb={0}>Parsing completed</Paragraph>
    </LineWrapper>
    <LineWrapper>
      <LeftIcon alt="tick" src={tickImg} />
      <Paragraph mb={0}>Assessments successfully added to hipages</Paragraph>
    </LineWrapper>
  </div>
);

export default ParseSucceeded;
